export enum EventContextType {
  FEATURED = 'FEATURED',
  BASE = 'BASE',
  SINGLE_EVENT = 'SINGLE_EVENT',
}
